import React, { createContext, useContext, useEffect, useState } from "react";

const BookingContext = createContext();

export const BookingProvider = ({ children }) => {
  const [bookingData, setBookingData] = useState({});

useEffect(() => {
  console.log("BookingProvider useEffect called");
  const updateData = () => {
    const storedKeys = [
      "arrival", "departure", "booker", "email", "guest-firstname", "guest-lastname",
      "hotel-id", "hotel-name", "journey-access-scope", "journey-capabilities", "pin-code",
      "reservation-code", "room-access", "room-number", "rooms", "telephone"
    ];
    const data = {};
    for (const key of storedKeys) {
      const item = localStorage.getItem(key);
      try {
        data[key] = JSON.parse(item);
      } catch {
        data[key] = item;
      }
    }
    setBookingData(data);
  };

  updateData(); // Initial load
  window.addEventListener("booking-update", updateData);
  return () => window.removeEventListener("booking-update", updateData);
}, []);

  return (
    <BookingContext.Provider value={bookingData}>
      {children}
    </BookingContext.Provider>
  );
};

export const useBooking = () => useContext(BookingContext);
